import React, { useContext } from 'react'
import * as R from 'ramda'
// import Team from '../../assets/images/team.png'
import styled, { ThemeProvider } from 'styled-components'
import { AppContext } from '../../store'
import './style.scss'

const pickColor = (option) => R.path(['theme', `color_${option}`])

const Container = styled.div`
  .container-section-fan {
    background: ${pickColor('tertiary')};
  }
  .container-texts {
    color: ${pickColor('label_on_tertiary')};
  }
`

export default function SectionFan() {
  const { state } = useContext(AppContext)
  const { contentful } = state

  const { team: { fields = {} } = {} } = contentful || {}

  return (
    <ThemeProvider theme={fields}>
      <Container>
        <section className='container-section-fan'>
          <section className='content-container'>
            <div className='container-img'>
              <img width='100%' height='100%' alt='Sobre' src={fields.panel_tag_image?.fields?.file?.url} />
            </div>
            <div className='container-texts'>
              <h1>{fields.panel_tag_title}</h1>
              <p>{fields.panel_tag_description}</p>
            </div>
          </section>
        </section>
      </Container>
    </ThemeProvider>
  )
}
